<nav aria-label="breadcrumb">
  <a [routerLink]="['/documents']">Accueil</a> <mat-icon>arrow_right</mat-icon> <span>Marché</span>
</nav>

<mat-card *ngIf="market">
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between">
    {{ market.name }}
    <button mat-raised-button color="primary" class="primary-button" (click)="createTypeSupport()" aria-label="Ajouter un type de support">
      <mat-icon>add</mat-icon>
      Ajouter un type de support
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content *ngIf="listTypeSupport.length > 0">
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="typeSupport">
        <mat-header-cell *matHeaderCellDef="let element">
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let ind = index" fxLayout="row" fxLayoutAlign="space-between">
          <div>
            <mat-icon *ngIf="isExpandedElement(ind)" (click)="collapseTypeSupport(element); setExpandedElement(ind)">expand_more</mat-icon>
            <mat-icon *ngIf="!isExpandedElement(ind)" matTooltip="Afficher les documents correspondants" 
              (click)="expandTypeSupport(element); setExpandedElement(ind)">chevron_right</mat-icon>
            <span>{{element?.name + ' (' + element?.nbDocument + ')'}}</span>
          </div>
          <div>
            <mat-icon matTooltip="Modifier ce type de support" (click)="editTypeSupport(element.id)">edit</mat-icon>
            <mat-icon id="selectFiles" matTooltip="Ajouter un document à ce type de support" (click)="addDocument(element)">add</mat-icon>
            <input multiple id="filesInput" class="hidden" (change)="onFileChange($event)" type="file" placeholder="Parcourir"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, image/png, image/jpeg, video/mp4">
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let detail; let row; let ind = index" class="collapse-row">
          <div *ngIf="row.element.documents">
            <div *ngFor="let doc of row.element.documents" [ngClass]="ind % 2 === 0 ? '' : 'line-impair'" fxLayout="row" fxLayoutAlign="space-between">
              <div>
                <mat-icon class="icons" *ngIf="doc.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                  doc.type === 'application/vnd.ms-excel' || doc.type === 'text/csv'">file_present</mat-icon>
                <mat-icon class="icons" *ngIf="doc.type ==='image/png' || doc.type === 'image/jpeg' || doc.type === 'application/octet-stream'">image</mat-icon>
                <mat-icon class="icons" *ngIf="doc.type ==='application/pdf'">picture_as_pdf</mat-icon>
                <mat-icon class="icons" *ngIf="doc.type ==='video/mp4'">play_circle</mat-icon>
                <span>{{doc?.name}}</span>
              </div>
              <mat-icon matTooltip="Supprimer ce document" (click)="deleteDocument(doc, row.element)">close</mat-icon>
            </div>
          </div>
          <div *ngIf="row?.element?.nbDocument === 0" [ngClass]="isExpandedElement(ind) ? 'line-impair' : ''" fxLayout="row" fxLayoutAlign="space-between">
            <span>Aucun document pour ce type de support</span>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"
        matRipple
        [class.expanded]="expandedElement == row">
      </mat-row>

      <mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow; let ind = index"
        [@detailExpand]="isExpandedElement(ind) ? 'expanded' : 'collapsed'"
        style="overflow: hidden; display: flex;" [ngClass]="isExpandedElement(ind) ? 'element-row' : 'hidden'">
      </mat-row>
    </mat-table>
  </mat-card-content>
</mat-card>